import React from "react";
import { Input, AutoComplete, Icon, Select } from "antd";
import {searchBeneficiaryNameForSelector} from "api/api";
import { displayGenericError } from "common/notifications";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

class BeneficiarySelectionComponent extends React.Component {
    state = {
        dataSource: [],
        searchResults: [],
        selection: null
    };

    searchTimerID = null;
    onChange = value =>{
        if (value === '') {
            this.props.onClear();
        } else {
            this.props.onChange(value);
        }
    }
    onSelect = value => {
        let selectedBeneficiary = null;
        for (let i = 0; i < this.state.searchResults.length; i++) {
            if (this.state.searchResults[i].id == value) {
                selectedBeneficiary = this.state.searchResults[i];
                break;
            }
        }
        this.props.onSelected(selectedBeneficiary);
    };

    handleSearch = value => {
        clearTimeout(this.searchTimerID);
        this.searchTimerID = setTimeout(() => {
            searchBeneficiaryNameForSelector(value, this.props.orginatorId, this.props.beneficiaryCountry, this.props.sourceCurrency, this.props.targetCurrency)
                .then(response => {
                    this.setState({
                        searchResults: response,
                        dataSource: response
                    });
                })
                .catch(error => {
                    displayGenericError(error);
                });
        }, 250);
    };

    renderOption = item => {
        return (
            <Select.Option key={item.id} text={item.fullName}>
                <span className="searchResult">{item.fullName}</span>
            </Select.Option>
        );
    };

    render() {
        const intl = this.props.useIntl;
        return (
            <div style={this.props.style}>
                <AutoComplete
                    className="global-search"
                    size="large"
                    style={{width: '100%'}}
                    dataSource={this.state.dataSource.map(this.renderOption)}
                    onChange={this.onChange}
                    onSelect={this.onSelect}
                    onSearch={this.handleSearch}
                    optionLabelProp="text"
                >
                    <Input
                        style={{...this.props.style}}
                        placeholder={intl.formatMessage({id: "app.component.beneficiaryselectioncomponent.beneficiaryname"})}
                        prefix={<Icon type="search" />}
                    />
                </AutoComplete>
            </div>
        );
    }
}

export default withUseIntl(BeneficiarySelectionComponent);